import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import ShiftPerformanceContent from './Boards/ShiftPerformanceContent';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import SmallDonutChart from './Charts/SmallDonutChart';
import MessageContent from '../Dashboard/MessageContent'
import { machineStatuses } from '../../Config/constants';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import Timer from '../Shared/Timer';
import { connect } from 'react-redux';  
import { useTranslation } from 'react-i18next';



export const ProductionLineContent = (props) => {
    const classes = useStyles();
    const [refresh, setRefresh] = useState(false)
    const [startTime, setStartTime] = useState(null)
    const { t } = useTranslation();

    useEffect(() => {
        let sortedStatusses = props.line.scissorStatuses.sort((a, b) => (new Date(b.startedOn)) - (new Date(a.startedOn)))
        let recentStatus = sortedStatusses[0]
        if (JSON.stringify(startTime) !== JSON.stringify(recentStatus.startedOn)) {

            setStartTime(recentStatus.startedOn)
        }
    }, [refresh])

    let statusColor = "";
    let icon = <React.Fragment></React.Fragment>

    let sortedStatusses = props.line.scissorStatuses.sort((a, b) => (new Date(b.startedOn)) - (new Date(a.startedOn)))

    let recentStatus = sortedStatusses[0]

    let status = ""
    if (recentStatus.name === machineStatuses.SCRAP) {
        status = machineStatuses.SCRAP
        icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
        statusColor = "#F59128";
    }
    else if (recentStatus.name === machineStatuses.UNPLANNEDSTOP) {
        status =   t("Unplanned stop")                                  
        statusColor = "#D84949";
        icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
    }
    else if (recentStatus.name === machineStatuses.PLANNEDSTOP) {
        status = machineStatuses.PLANNEDSTOP
        statusColor = FlagstoneTheme.palette.primary.main;
        icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
    }
    else {
        status = machineStatuses.PRODUCTION;
        statusColor = "#5CC958";
        icon = <InfoIcon className={classes.infoIcon}></InfoIcon>;
    }

    const refreshProductionLine = () => {
        setRefresh(!refresh)
    }

    return (
        <React.Fragment>
            <div className={classes.productionLineContainer} style={{ border: props.border }}>
                <div className={classes.header}>
                    <div className={classes.workstationId}>
                        {props.line.id}
                    </div>
                    <div className={classes.border1}>
                    </div>
                    <div className={classes.statusContainer}>
                        <div className={classes.status}>
                            <div className={classes.statusIcon} style={{ color: statusColor }}>
                                {icon}
                            </div>
                            <div className={classes.statusText} style={{ color: statusColor }}>
                                {status}
                            </div>
                        </div>
                        <div className={classes.duration}>
                            {startTime && <Timer refresh = {refreshProductionLine} startTime={startTime} line={props.line} actions={props.actions} ></Timer>}
                        </div>
                    </div>
                </div>
                <ShiftPerformanceContent fakeDataWorkstation={props.fakeDataWorkstation}></ShiftPerformanceContent>
                <div className={classes.border2}></div>
                <div className={classes.performanceSharts}>
                    <SmallDonutChart value={props.fakeDataWorkstation.quality} label={"Quality"}></SmallDonutChart>
                    <SmallDonutChart value={props.fakeDataWorkstation.performance} label={"Performance"}></SmallDonutChart>
                    <SmallDonutChart value={props.fakeDataWorkstation.availability} label={"Availability"}></SmallDonutChart>
                </div>
                <div className={classes.border3}></div>
                <div className={classes.messagesContainer}>
                    {props.fakeDataWorkstation.messages.slice(props.fakeDataWorkstation.messages.length - 2, props.fakeDataWorkstation.messages.length).map(x => <MessageContent key={x.id} message={x} textWidth={"240px"} iconPadding={"8px"} messageHeight={"65px"} backgroundColor={"#F4F4F4"}></MessageContent>)}
                </div>
            </div>
        </React.Fragment>
    )

}

const useStyles = makeStyles(() => ({
    productionLineContainer: {
        width: "300px",
        height: "655px",
        backgroundColor: "white",
        float: "left",
        margin: "5px",
        borderRadius: "5px",
        padding: "15px",
        boxSizing: "borderBox"
    },
    errorIcon: {
        width: "27px",
        height: "27px",
    },
    infoIcon: {
        width: "27px",
        height: "27px",

    },
    workstationId: {
        fontSize: "67px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#DEDEDE',
        width: "50px",
        height: "80px",
        float: "left"
    },
    border1: {
        float: "left",
        width: "15px",
        height: "60px",
        marginTop: "10px",
        borderRight: "1px solid #DEDEDE"
    },
    border2: {
        width: "100%",
        height: "5px",
        borderBottom: "1px solid #DEDEDE"
    },
    border3: {
        width: "100%",
        height: "150px",
        borderBottom: "1px solid #DEDEDE",
        marginBottom: "20px"
    },
    header: {
        width: "100%",
        height: "85px",
        borderBottom: "1px solid #DEDEDE",
        marginBottom: "15px"
    },
    statusContainer: {
        float: "left",
        paddingTop: "15px",
        paddingLeft: "15px"

    },
    statusText: {
        fontSize: "24px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        textTransform: "capitalize",
        float: "left",
        position: "relative",
    },
    statusIcon: {
        float: "left",
        marginRight: "5px"

    },
    duration: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100"
    },
    status: {

        height: "35px"
    }
}));

function mapStateToProps(state) {
    return {
        workstationState: state.workstationState,
    }
}

export default connect(mapStateToProps)(ProductionLineContent)